import { Route, Routes } from 'react-router-dom'
import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import TasksLandingPage from './TasksLandingPage/TasksLandingPage'

export default function TasksRoute() {
  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route path="" element={<TasksLandingPage />}>
          {/* <Route path="inspection" element={<AddListInspectionTemplate />} /> */}
        </Route>
      </Routes>
    </ErrorBoundaryComponent>
  )
}
